import _ from "lodash";
import * as types from "../types";

export const getForumTopics = ({ page, perPage }) => ({
  type: types.GET_FORUM_TOPICS,
  request: {
    url: "/forum_topics",
    method: "GET",
    params: {
      "q[s]": ["created_at desc", "title asc"],
      page,
      per_page: perPage
    }
  }
});

export const getForumTopic = ({ id }) => ({
  type: types.GET_FORUM_TOPIC,
  request: {
    url: `/forum_topics/${id}`,
    method: "GET"
  }
});

export const createForumTopic = ({ title, body }) => ({
  type: types.CREATE_FORUM_TOPIC,
  request: {
    url: `/forum_topics`,
    method: "POST",
    data: {
      forumTopic: {
        title,
        body
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_FORUM_TOPICS]: (prevData, newData) => {
        return { ...prevData, data: [newData.data, ...prevData.data] };
      }
    }
  }
});

export const updateForumTopic = ({ id, title, body }) => ({
  type: types.UPDATE_FORUM_TOPIC,
  request: {
    url: `/forum_topics/${id}`,
    method: "PATCH",
    data: {
      forumTopic: {
        title,
        body
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_FORUM_TOPIC]: (prevData, newData) => {
        return { ...prevData, data: { ...newData.data } };
      }
    }
  }
});

export const getForumPosts = ({ forumTopicId, page, perPage }) => ({
  type: types.GET_FORUM_POSTS,
  request: {
    url: `/forum_topics/${forumTopicId}/forum_posts`,
    method: "GET",
    params: {
      "q[s]": ["created_at asc", "title asc"],
      page,
      per_page: perPage
    }
  }
});

export const createForumPost = ({ forumTopicId, body }) => ({
  type: types.CREATE_FORUM_POST,
  request: {
    url: `/forum_topics/${forumTopicId}/forum_posts`,
    method: "POST",
    data: {
      forumPost: {
        body
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_FORUM_POSTS]: (prevData, newData) => {
        return { ...prevData, data: [...prevData.data, newData.data] };
      }
    }
  }
});

export const updateForumPost = ({ id, body, published }) => ({
  type: types.CREATE_FORUM_POST,
  request: {
    url: `/forum_posts/${id}`,
    method: "PATCH",
    data: {
      forumPost: {
        body,
        published
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_FORUM_POSTS]: (prevData, newData) => {
        if (!newData.data.published) {
          _.remove(prevData.data, post => post.id === newData.data.id);
        } else {
          const index = _.findIndex(prevData.data, { id: newData.data.id });
          prevData.data.splice(index, 1, newData.data);
        }
        return { ...prevData };
      }
    }
  }
});
